import React from "react";
import { get} from "react-hook-form";
import ErrorBlock from "./error";


function getValueByKeyForNumberEnum(source, value) {
  return Object.entries(source).find(([key, val]) => key === value)?.[1];
}

const FormCheckbox = ({
  name,
  label,
  register,
  error,
  containerClass = "checkbox-fields",
  options,
  registerOptions,
  text,
  ...rest
}) => {
  return (
    <div className={containerClass} >
      {label && <label className="input-label" htmlFor={name}>{label}</label>}
      {text &&
        <p>
          <small className="form-text text-muted">{text}</small>
        </p>
      }

      {
        Object.keys(options).map((option, index) =>
        (
            <div key={index} className="checkbox-field">
              <input className='inp-cbx' id={`cbx-${name}-${index}`} type="checkbox" value={getValueByKeyForNumberEnum(options, option)} {...register(name, { ...registerOptions })} />
              <label htmlFor={`cbx-${name}-${index}`} className="cbx" key={`label-for-${option}`} >
                <span>
                  <svg width="12px" height="10px" viewBox="0 0 12 10">
                    <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                  </svg>
                </span>
                <span>{getValueByKeyForNumberEnum(options, option)}</span>
              </label>
            </div>)
        )
      }

      {error && <ErrorBlock error={error} />}
    </div >
  )
};

export const renderCheckbox = (
  name,
  errors,
  register,
  { label, placeholder, registerOptions, text, containerClass, options },
) =>
  <FormCheckbox
    containerClass={containerClass}
    name={name}
    label={label}
    text={text}
    placeholder={placeholder}
    error={get(errors, name)?.message}
    register={register}
    registerOptions={registerOptions}
    options={options} />

FormCheckbox.displayName = "FormCheckbox";

export default FormCheckbox
